export default class MobileMenu {
	constructor() {
		const searchInput = document.querySelector('.search-form__input');
		const searchToggle = document.querySelector('.search-toggle');
		const searchClose = document.querySelector('.search-close');

		if (searchInput) {
			document.body.classList.add('has-search-bar');
		} else {
			document.body.classList.add('has-no-search-bar');
		}

		const checkIfEscape = (e) => {
			if (e.key === 'Escape') {
				closeSearch();
			}
		};

		const toggleSearch = () => {
			document.body.classList.toggle('has-search-open');

			if (document.body.classList.contains('has-search-open')) {
				searchInput.focus();
			}

			searchToggle.classList.toggle('open');
		};

		const closeSearch = () => {
			document.body.classList.remove('has-search-open');

			searchToggle.classList.remove('open');
			document.removeEventListener('keydown', checkIfEscape);
		};

		if (searchToggle) {
			searchToggle.addEventListener('click', () => {
				toggleSearch();
			});
		}
	}
}
